import { render, staticRenderFns } from "./back-current.vue?vue&type=template&id=068a982c&scoped=true&"
import script from "./back-current.vue?vue&type=script&lang=js&"
export * from "./back-current.vue?vue&type=script&lang=js&"
import style0 from "./back-current.vue?vue&type=style&index=0&id=068a982c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a982c",
  null
  
)

export default component.exports